import { GridColDef } from "@mui/x-data-grid";

const formatAverageValue = (value: unknown): string => {
	if (typeof value !== "number" || !Number.isFinite(value)) return "0.00";
	return value.toFixed(2);
};

/**
 * Returns column definitions for the KPI DataGrid.
 */
export function getKpiColumns(): GridColDef[] {
	return [
		{
			field: "Name",
			headerName: "KPI Name",
			flex: 1.25,
			minWidth: 180,
		},
		{
			field: "Average",
			headerName: "Average",
			flex: 0.6,
			minWidth: 120,
			type: "number",
			headerAlign: "right",
			align: "right",
			valueFormatter: (value) => formatAverageValue(value),
		},
		{
			field: "Count",
			headerName: "Count",
			flex: 0.5,
			minWidth: 100,
			type: "number",
			headerAlign: "right",
			align: "right",
		},
	];
}

export enum KpiField {
	Average = "Average",
	Count = "Count",
}
